let Backbone = require("backbone");
import MenuCategoryModel from "../model/MenuCategoryModel.js";
import i18n from "../utils/i18n";

let main = function (Backbone, MenuCategoryModel, i18n) {
    return Backbone.Collection.extend({
        model: MenuCategoryModel,
        url: '/pos/categoryList',

        getAvailableCategories: function () {
            var availableCollection = new Backbone.Collection();
            this.each(function (item) {
                if (availableCollection.size() == 1) {
                    var firstCategory = availableCollection.first();
                    var obj = availableCollection.first().clone();
                    obj.set({"name": i18n.msg("pos.all")});
                    obj.set({"id": 0});
                    availableCollection = new Backbone.Collection();
                    availableCollection.push(obj);
                    availableCollection.push(firstCategory);
                }
                if (item.get("menuItems").where({status: 'Available'}).length > 0) {
                    availableCollection.add(item);
                }
            });
            return availableCollection;
        }
    });
};

let exportedValue = main(Backbone, MenuCategoryModel, i18n);
export default exportedValue;



// WEBPACK FOOTER //
// ./src/collection/MenuCategoryCollection.js